package com.wintermar.inspection.core.ui.component.input.util

enum class InputValidationType {
    MIN_CHAR,
    EMAIL,
    MANDATORY,
}
